var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cases", class: _vm.getVariant("cases") },
    [
      _c(
        "image-view",
        {
          attrs: {
            variant: "is-dark",
            skills: _vm.caseStudy.skills,
            "image-id": _vm.caseStudy.image.url,
            "mobile-image-id": _vm.caseStudy.mobileimage.url
          },
          scopedSlots: _vm._u([
            {
              key: "skill",
              fn: function(props) {
                return [
                  _c("text-view", { attrs: { variant: "skill" } }, [
                    _c("p", [_vm._v(_vm._s(props.skill))])
                  ])
                ]
              }
            }
          ])
        },
        [
          _c("template", { slot: "title-small" }, [
            _vm._v("\n      " + _vm._s(_vm.caseStudy.client) + "\n    ")
          ]),
          _c("template", { slot: "title-normal" }, [
            _vm._v("\n      " + _vm._s(_vm.caseStudy.name) + "\n    ")
          ]),
          _c(
            "template",
            { slot: "skill-title" },
            [
              _c("text-view", { attrs: { variant: "skill" } }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("skills")))])
              ])
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "cases__content", attrs: { variant: "plus-margin" } },
        [
          _c("title-view", { attrs: { variant: "primary " } }, [
            _vm._v("\n      " + _vm._s(_vm.caseStudy.name) + "\n    ")
          ]),
          _c("div", { staticClass: "has-max-width" }, [
            _c(
              "div",
              {
                staticClass: "cases__content",
                class: "has-max-width--padding"
              },
              [
                _c("title-view", { attrs: { variant: "subtitle" } }, [
                  _c("span", [_vm._v(_vm._s(_vm.caseStudy.lead))])
                ])
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._l(_vm.caseStudy.items, function(item, index) {
        return _c("div", { key: index }, [
          _c("div", { staticClass: "has-max-width--padding" }, [
            item.type === _vm.typeCase.TYPE_TEXT
              ? _c(
                  "div",
                  { staticClass: "cases__content" },
                  [
                    _c(
                      "title-view",
                      {
                        attrs: {
                          variant:
                            "small small-margin align-left no-padding black"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " + _vm._s(item.title) + "\n        "
                        )
                      ]
                    ),
                    _c("text-view", {
                      attrs: { variant: "align-left normal" },
                      domProps: { innerHTML: _vm._s(item.text) }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]),
          item.type === _vm.typeCase.TYPE_IMAGE
            ? _c("div", { class: { "has-max-width": !item.style.HasMargin } }, [
                _c("div", { staticClass: "cases__big-image" }, [
                  _c("picture", [
                    _c("source", {
                      attrs: {
                        media: "--small",
                        "data-srcset": item.mobileimage.url
                      }
                    }),
                    _c("source", {
                      attrs: { media: "--large", "data-srcset": item.image.url }
                    }),
                    _c("img", {
                      staticClass: "lazyload",
                      attrs: {
                        "data-sizes": "auto",
                        "data-src": item.image.url
                      }
                    })
                  ])
                ])
              ])
            : _vm._e(),
          item.type === _vm.typeCase.TYPE_VIDEO
            ? _c(
                "div",
                [
                  _c(
                    "video-thumbnail-inline-view",
                    {
                      attrs: {
                        variant: _vm.getVideoWidth(item.fullwidth),
                        "video-id": item.vimeourl
                      }
                    },
                    [
                      _c("template", { slot: "image" }, [
                        _c("picture", [
                          _c("source", {
                            attrs: {
                              media: "--small",
                              "data-srcset": item.mobilethumbnail.url
                            }
                          }),
                          _c("source", {
                            attrs: {
                              media: "--large",
                              "data-srcset": item.thumbnail.url
                            }
                          }),
                          _c("img", {
                            staticClass: "lazyload",
                            attrs: {
                              "data-sizes": "auto",
                              "data-src": item.thumbnail.url
                            }
                          })
                        ])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          item.type === 3
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticClass: "has-max-width",
                      class: "has-max-width--padding"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "cases__content",
                          class: "cases__content--full"
                        },
                        [
                          _c(
                            "title-view",
                            {
                              attrs: {
                                variant:
                                  "small small-margin align-left no-padding black"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(item.title) +
                                  "\n          "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._l(item.items, function(storyItem, ind) {
                    return _c("div", { key: ind }, [
                      storyItem.type === _vm.typeCase.TYPE_TEXT
                        ? _c(
                            "div",
                            {
                              staticClass: "cases__content",
                              class: "has-max-width--padding"
                            },
                            [
                              _c(
                                "text-view",
                                {
                                  attrs: {
                                    variant: "align-left normal no-pre-line"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(storyItem.text) +
                                      "\n          "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      storyItem.type === _vm.typeCase.TYPE_IMAGE
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                class: { "has-max-width": !storyItem.fullwidth }
                              },
                              [
                                _c("picture", [
                                  _c("source", {
                                    attrs: {
                                      media: "--small",
                                      "data-srcset": storyItem.mobileimage.url
                                    }
                                  }),
                                  _c("source", {
                                    attrs: {
                                      media: "--large",
                                      "data-srcset": storyItem.image.url
                                    }
                                  }),
                                  _c("img", {
                                    staticClass: "lazyload",
                                    attrs: {
                                      "data-sizes": "auto",
                                      "data-src": storyItem.image.url
                                    }
                                  })
                                ])
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  })
                ],
                2
              )
            : _vm._e(),
          item.type === _vm.typeCase.TYPE_AWARDS
            ? _c(
                "div",
                { staticClass: "cases__awards" },
                [
                  _c("title-view", { attrs: { variant: "big" } }, [
                    _vm._v("\n        " + _vm._s(_vm.$t("awards")) + "\n      ")
                  ]),
                  _c(
                    "section",
                    { staticClass: "center grid-2-spaceAround" },
                    _vm._l(item.items, function(award, i) {
                      return _c(
                        "div",
                        { key: i, staticClass: "col-6_sm-12" },
                        [
                          _c("award-view", {
                            attrs: { title: award.title, year: award.year }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e(),
          item.type === _vm.typeCase.TYPE_BUTTONLIST
            ? _c(
                "div",
                { staticClass: "cases__buttons" },
                [
                  _c("title-view", { attrs: { variant: "primary " } }, [
                    _vm._v("\n        " + _vm._s(item.heading) + "\n      ")
                  ]),
                  _c(
                    "section",
                    {
                      staticClass:
                        "cases__buttons__grid center grid-center-spaceAround"
                    },
                    _vm._l(item.items, function(button, i) {
                      return _c("div", { key: i, staticClass: "col-6_sm-12" }, [
                        button.type.id === _vm.typeButtonCase.TYPE_IOS
                          ? _c(
                              "div",
                              { staticClass: "cases__buttons__grid__button" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: button.action,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._m(0, true)]
                                )
                              ]
                            )
                          : _vm._e(),
                        button.type.id === _vm.typeButtonCase.TYPE_ANDROID
                          ? _c(
                              "div",
                              { staticClass: "cases__buttons__grid__button" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: button.action,
                                      target: "_blank"
                                    }
                                  },
                                  [_vm._m(1, true)]
                                )
                              ]
                            )
                          : _vm._e(),
                        button.type.id === _vm.typeButtonCase.TYPE_WEB
                          ? _c(
                              "div",
                              { staticClass: "cases__buttons__grid__button" },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: button.action,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c(
                                      "button-view",
                                      { attrs: { variant: "primary full" } },
                                      [
                                        _c("i", {
                                          staticClass: "icon-website"
                                        }),
                                        _c("span", [
                                          _vm._v(_vm._s(button.label))
                                        ])
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    }),
                    0
                  )
                ],
                1
              )
            : _vm._e()
        ])
      }),
      _c("footer-contact-view")
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("picture", [
      _c("source", {
        attrs: {
          media: "--small",
          "data-srcset": "/static/images/appstore.png"
        }
      }),
      _c("source", {
        attrs: {
          media: "--large",
          "data-srcset": "/static/images/appstore@2x.png"
        }
      }),
      _c("img", {
        staticClass: "lazyload",
        attrs: {
          "data-sizes": "auto",
          "data-src": "/static/images/appstore@2x.png"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("picture", [
      _c("source", {
        attrs: {
          media: "--small",
          "data-srcset": "/static/images/googleplay.png"
        }
      }),
      _c("source", {
        attrs: {
          media: "--large",
          "data-srcset": "/static/images/googleplay@2x.png"
        }
      }),
      _c("img", {
        staticClass: "lazyload",
        attrs: {
          "data-sizes": "auto",
          "data-src": "/static/images/googleplay@2x.png"
        }
      })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a5b92032", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5b92032","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/work/show.vue
// module id = 527
// module chunks = 1